import { jsx as _jsx } from "react/jsx-runtime";
const Tag = ({ label }) => {
    return (_jsx("div", { className: "inline-block transition-all duration-200 bg-gold px-4 py-2 group-hover:bg-green", children: _jsx("p", { className: "tag text-white", children: label }) }));
};
export default Tag;
